import { SpanishDprPeriod } from './SpanishDprPeriod';
import { type SanitizedSpainClosurePeriod } from './helpers/sanitizePeriodsList';

export function SpanishDprPeriodsList({
  periods,
}: {
  periods: SanitizedSpainClosurePeriod[];
}) {
  if (periods.length === 0) {
    return null;
  }
  return (
    <div className="border-border-default bg-background-primary-default rounded-8 flex flex-col self-stretch overflow-hidden border">
      {periods.map((period, index) => (
        <SpanishDprPeriod
          key={period.from}
          period={period}
          className={index !== 0 ? 'border-border-default border-t' : ''}
        />
      ))}
    </div>
  );
}
